var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-indicator',{attrs:{"loading":_vm.isLoading}}),(!_vm.isLoading)?[(_vm.logs.length > 0)?[_c('log-changes',{attrs:{"history":_vm.logs}})]:[_c('lang',{attrs:{"labelKey":"PIM-PRODUCT-NO_LOGS_AVAILABLE"}})]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }